import type { EventType } from './event';

export interface BoardPostAgeGroup {
  id: number;
  name: string;
}

export interface BoardPost {
  id: number;
  content: string;
  /** Az egész klubnak szól; ilyenkor az ageGroups üres. */
  isClubWide: boolean;
  /** A vendégeknek (gondnok, kitmanager, külsős csapat) is szól. */
  isForGuests: boolean;
  ageGroups: BoardPostAgeGroup[];
  isPinned: boolean;
  expiresAt?: string | null;
  isExpired: boolean;
  commentsEnabled: boolean;
  /** Az esemény, amihez a bejegyzés kapcsolódik. */
  event?: BoardPostEvent | null;
  createdAt: string;
  updatedAt?: string | null;
  authorUserId: number;
  authorName: string;
  commentCount: number;
  /** Olvasta-e már a bejelentkezett felhasználó. */
  isReadByMe: boolean;
  /** Hányan olvasták. Csak a szerző és az admin kapja meg, másnak null. */
  readCount?: number | null;
  /** Szerkesztheti/törölheti-e a bejelentkezett felhasználó. */
  canModify: boolean;
  /** Hozzászólhat-e: a bejegyzésen engedélyezve van, és a klub beállítása is engedi. */
  canComment?: boolean;
}

export interface BoardPostEvent {
  id: number;
  title: string;
  type: EventType;
  startTime: string;
}

/** Mit tehet a bejelentkezett felhasználó az üzenőfalon. */
export interface BoardPermissions {
  canPost: boolean;
  canPostClubWide: boolean;
  canPostForGuests: boolean;
  canPin: boolean;
  /** A klub beállítása szerint hozzászólhat-e. */
  canComment: boolean;
  /** A korosztályok, amiknek bejegyzést írhat. */
  ageGroups: BoardPostAgeGroup[];
}

export interface BoardPostComment {
  id: number;
  boardPostId: number;
  content: string;
  createdAt: string;
  updatedAt?: string | null;
  userId: number;
  userName: string;
}

export interface BoardPostReader {
  userId: number;
  name: string;
  readAt: string;
}

export interface CreateBoardPostRequest {
  content: string;
  isClubWide: boolean;
  isForGuests: boolean;
  ageGroupIds: number[];
  isPinned: boolean;
  /** Null = nem jár le magától. */
  expiresAt?: string | null;
  commentsEnabled: boolean;
  /** Menjen-e push értesítés a címzetteknek. */
  notify: boolean;
  /** Az esemény, amihez kapcsolódik (nem kötelező). */
  eventId?: number | null;
}

export interface UpdateBoardPostRequest {
  content?: string;
  isClubWide?: boolean;
  isForGuests?: boolean;
  ageGroupIds?: number[];
  isPinned?: boolean;
  /** A lejárat törléséhez ezt kell true-ra állítani (a null "ne nyúlj hozzá"). */
  clearExpiresAt?: boolean;
  expiresAt?: string | null;
  commentsEnabled?: boolean;
  eventId?: number | null;
  /** Az eseményhez kötés megszüntetése. */
  clearEvent?: boolean;
}

/**
 * A bejegyzés címzettjeinek felirata: klubszintűnél egyetlen "Egész klub"
 * címke, egyébként a korosztályok nevei - ugyanúgy badge-ként, ahogy az
 * eseményeknél a korosztály megjelenik.
 */
export const boardPostAudienceLabels = (post: BoardPost): string[] => {
  const labels = post.isClubWide ? ['Egész klub'] : post.ageGroups.map((ag) => ag.name);
  if (post.isForGuests) labels.push('Vendégek');
  return labels;
};
